import { useTranslation } from 'react-i18next';

import { LostDamagedPalletsByClientItem } from 'interfaces';

import AdditionalFeeListItem from '../AdditionalFeeListItem/AdditionalFeeListItem';
import styles from '../AdditionalFeeWarning.module.css';

type AdditionalFeeSectionProps = {
   damageType: string;
   totalAmount: number;
   pricesForPallets: LostDamagedPalletsByClientItem[];
   multipleLine?: boolean;
   sumPerCategory?: number;
   sumLine?: boolean;
};

const AdditionalFeeSection = ({
   damageType,
   totalAmount,
   pricesForPallets,
   multipleLine,
   sumPerCategory,
   sumLine,
}: AdditionalFeeSectionProps) => {
   const { t } = useTranslation();

   return (
      <>
         <p>{t('additionalFeeSection.singleLine', { damageType })}</p>
         <ul className={styles.additionalFeeList}>
            {pricesForPallets?.map((el, index) => (
               <AdditionalFeeListItem element={el} key={index} />
            ))}
         </ul>
         <p>
            <b>{t('additionalFeeSection.subTotal', { value: sumPerCategory })}</b>
         </p>
         <br />
         {sumLine && (
            <p>
               <b>{t('additionalFeeSection.totalLine', { totalAmount })}</b>
            </p>
         )}

         {multipleLine && <p>{t('additionalFeeSection.willBeAdded')}</p>}
      </>
   );
};

export default AdditionalFeeSection;
